import { render, staticRenderFns } from "./CompanySetting.vue?vue&type=template&id=d321d510&scoped=true"
import script from "./CompanySetting.vue?vue&type=script&lang=js"
export * from "./CompanySetting.vue?vue&type=script&lang=js"
import style0 from "./CompanySetting.vue?vue&type=style&index=0&id=d321d510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d321d510",
  null
  
)

export default component.exports